// @flow

/* eslint-disable react-hooks/exhaustive-deps */

import * as React from 'react';
import { useRouterChanging } from '../controls/router';
import {
  cancelAnimationTimeout,
  requestAnimationTimeout,
} from '../utils/animation-timeout';

// The idea is to wait a little if route change will occured,
// and if it is this hook highly improve visual loading behaviour for cached data

export const useScrollTopOnRouteChangeTimeout = <T: string>(anchorRef?: {|
  current: React.ElementRef<T> | null,
|}): (() => void) => {
  const changing = useRouterChanging();

  const changingPrevRef = React.useRef(changing);
  const animTimeoutHandleRef = React.useRef(null);

  React.useEffect(() => {
    if (changingPrevRef.current === false && changing) {
      if (animTimeoutHandleRef.current != null) {
        cancelAnimationTimeout(animTimeoutHandleRef.current);
        animTimeoutHandleRef.current = null;
        if (anchorRef != null) {
          anchorRef.current && anchorRef.current.scrollIntoView();
        } else {
          window.scrollTo({ top: 0 });
        }
      }
    }

    changingPrevRef.current = changing;
  }, [changing]);

  React.useEffect(
    () => () => cancelAnimationTimeout(animTimeoutHandleRef.current),
    [],
  );

  return () => {
    const SMALL_DELAY_BEFORE_SCROLL = 100;

    animTimeoutHandleRef.current = requestAnimationTimeout(
      SMALL_DELAY_BEFORE_SCROLL,
      () => {
        animTimeoutHandleRef.current = null;
        if (anchorRef != null) {
          anchorRef.current && anchorRef.current.scrollIntoView();
        } else {
          window.scrollTo({ top: 0 });
        }
      },
    );
  };
};
